import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class JobLogApi extends DbCenterBaseApi {

  public get ControllerName(): any {
    return 'joblog';
  }

  /**
   * 查询分页列表
   */
  public getJobLogById(jobId) {
    return this.send({ jobId: jobId }, "getJobLogById", Methods.GET);
  }

/**
   * 查询分页列表
   */
 public pageLogList(start, length, jobGroup, jobId, logStatus, filterTime) {
  return this.send({ start: start, length: length, jobGroup: jobGroup, jobId: jobId, logStatus: logStatus, filterTime: filterTime}, "pageLogList", Methods.GET);
}

}